import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BarChart3, Users, CreditCard, TrendingUp, Receipt } from 'lucide-react';

const tabs = [
  { id: 'overview', label: 'Overview', icon: BarChart3, path: '/admin/financial' },
  { id: 'subscribers', label: 'Subscribers', icon: Users, path: '/admin/financial/subscribers' },
  { id: 'payments', label: 'Payments', icon: CreditCard, path: '/admin/financial/payments' },
  { id: 'forecast', label: 'Forecast', icon: TrendingUp, path: '/admin/financial/forecast' },
  { id: 'receipts', label: 'Receipts', icon: Receipt, path: '/admin/financial/receipts' },
];

const FinancialTabNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="bg-white border-b border-gray-200 px-6 pt-6 pb-0">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 mb-4">
          <BarChart3 className="w-6 h-6 text-blue-600" />
          <h1 className="text-xl font-bold text-gray-900">Financial Dashboard</h1>
        </div>
        <div className="flex gap-1 overflow-x-auto">
          {tabs.map(tab => {
            const isActive = location.pathname === tab.path ||
              (tab.path === '/admin/financial' && location.pathname === '/admin/financial');
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => navigate(tab.path)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-t-lg transition whitespace-nowrap ${
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FinancialTabNav;
